import { Banner } from 'domains/banners';
import style from './style.module.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import './navigation.css';
import { Navigation, Mousewheel } from 'swiper';
import { LastOrder } from 'domains/cart';
import {
  Banner as BannerComponent,
  GiftRepurchaseBanner,
  LastOrderBannner,
  SkeletonBanners,
} from './components';
import clsx from 'clsx';
import { GiftRepurschase } from 'domains/giftRepurschases';
import { CurrencySymbol } from 'models';

const BannersList = ({
  hasHeading = false,
  banners,
  giftRepurchases,
  lastOrder,
  products,
  isPendingBanners,
  currency,
}: {
  hasHeading?: boolean;
  currency: CurrencySymbol;
  banners: Banner[];
  lastOrder: LastOrder | null;
  giftRepurchases: GiftRepurschase[];
  products: {
    productId: string;
    productName: string;
    categoryId: string;
    categoryName: string;
  }[];
  isPendingBanners: boolean;
}) => {
  const idGropuedProducts = Object.fromEntries(
    products.map((product) => [product.productId, product]),
  );
  return (
    <div className={clsx(style.banners, hasHeading && style.withHeading)}>


      {!isPendingBanners ? (
        <Swiper
          initialSlide={0}
          spaceBetween={12}
          navigation={true}
          mousewheel={true}
          modules={[Navigation, Mousewheel]}
          direction='horizontal'
          slidesPerView={'auto'}
          className={style.list}
        >
          {lastOrder !== null && (
            <SwiperSlide
              className={clsx(style.banner, style.banner__lastOrder)}
            >
              <LastOrderBannner lastOrder={lastOrder} />
            </SwiperSlide>
          )}
          {giftRepurchases.map((giftRepurchase, i) => (
            <SwiperSlide
              key={giftRepurchase.id}
              className={clsx(style.banner, style.banner__giftRepurchase)}
            >
              <GiftRepurchaseBanner
                {...{ giftRepurchase, currency, products: idGropuedProducts }}
              />
            </SwiperSlide>
          ))}
          {banners.map((banner, i) => (
            <SwiperSlide
              key={banner.id}
              className={clsx(style.banner, style.banner__story)}
            >
              <BannerComponent products={idGropuedProducts} banner={banner} />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <SkeletonBanners showLastOrderBanner={false} />
      )}
    </div>
  );
};

export default BannersList;
